export default __webpack_public_path__ + "static/media/architecture.16297cae.svg";